/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.SwapGroups {
    angular.module("meevo.plugins.swapGroups", []);
}